import { Box, Button, Fade, Icon, Link, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import React, { useContext, useState } from 'react';
import { AuthContext, ConferenceContext, UserContext } from '@/store';
import UserAvatar from '@/components/ui/userAvatar';
import C from '@shared/constants/general';
import { useListsStyle } from '@/js/shared/components/lists/lists.styles';

const formatFieldValue = (value) => {
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return value;
};

const FollowToggle = (props) => {
  const theme = useTheme();
  const classes = useListsStyle(theme).followToggle;
  const { authState } = useContext(AuthContext);
  const { actions } = useContext(UserContext);
  const { conferenceState, openNewThreadPopup, canIStartChat } = useContext(
    ConferenceContext
  ); // Hämta Context
  const [messageText, setMessageText] = useState('');
  const [updated, setUpdated] = useState(true);
  const [addMessage, setAddMessage] = useState(false);

  // Settings default to shown when the flag is absent (older conferences).
  const settings = window.SETTINGS || {};
  const showLinkedIn = settings.SHOW_REGISTRATION_LINKEDIN !== false;
  const showCustomFields = settings.SHOW_REGISTRATION_CUSTOM_FIELD !== false;
  const showProfileCardActions = settings.SHOW_PROFILE_CARD_ACTIONS !== false;

  const customRegistrationFields = (
    props.user.custom_registration_fields || []
  ).filter(
    (field) =>
      field.value !== null && field.value !== undefined && field.value !== ''
  );

  const toggleFollow = () => {
    setUpdated(false);
    actions.updateFollowing(
      props.user.id,
      !props.user.youAreFollowing,
      messageText,
      (updatedUser) => {
        setTimeout(() => {
          setUpdated(true);
          setMessageText('');
          setAddMessage(false);
          props.updatedCallback && props.updatedCallback(updatedUser);
        }, 200);
      }
    );
  };

  return (
    <Box>
      <Fade in={updated} timeout={{ appear: 300, exit: 300 }}>
        {props.user.youAreFollowing ? (
          <Box pb={1}>
            {props.user.followsYou ? (
              <>
                <em>{window.LANG.ECARD_EXCHANGED_HI}</em>
                {props.user.following[0].visitorFollowings.text && (
                  <Box p={1}>
                    <em>"{props.user.following[0].visitorFollowings.text}"</em>
                  </Box>
                )}
                {showProfileCardActions && (
                  <Box sx={classes.miniEcard} display="flex">
                    <Box sx={classes.miniEcardAvatar}>
                      <UserAvatar size="medium" user={props.user} />
                    </Box>
                    <Box sx={classes.miniEcardInfo} flexGrow={1}>
                      <Box sx={classes.miniEcardRow}>
                        <Icon sx={classes.miniEcardIcon} fontSize="small">
                          mail_outline
                        </Icon>
                        <Link
                          href={`mailto:${props.user.email}`}
                          sx={classes.miniEcardValue}
                        >
                          {props.user.email}
                        </Link>
                      </Box>
                      <Box sx={classes.miniEcardRow}>
                        <Icon sx={classes.miniEcardIcon} fontSize="small">
                          phone
                        </Icon>
                        <Box component="span" sx={classes.miniEcardValue}>
                          {props.user.phone || window.LANG.ECARD_NO_PHONE}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}
              </>
            ) : (
              <>
                <em>
                  {window.LANG.ECARD_REQUESTED_TITLE} <br />
                  {window.LANG.ECARD_REQUESTED_MSG}
                </em>
              </>
            )}
            <br />
            <Button
              fullWidth
              onClick={toggleFollow}
              color="secondary"
              variant="contained"
              startIcon={<Icon>remove_circle</Icon>}
              sx={classes.actionBtn}
            >
              {props.user.followsYou
                ? window.LANG.ECARD_TAKE_BACK
                : window.LANG.ECARD_REGRET_ASKING}
            </Button>
          </Box>
        ) : (
          <Box>
            {props.user.followsYou ? (
              <>
                <em>
                  {window.LANG.ECARD_ASKED_TITLE} <br />
                  {window.LANG.ECARD_ASKED_MSG}
                </em>
                <br />
                {props.user.following[0].visitorFollowings.text && (
                  <Box p={1}>
                    <em>"{props.user.following[0].visitorFollowings.text}"</em>
                  </Box>
                )}
                <br />
              </>
            ) : (
              showProfileCardActions && (
                <Box sx={classes.miniEcard} display="flex" mb={1}>
                  <Box sx={classes.miniEcardAvatar}>
                    <UserAvatar size="medium" user={props.user} />
                  </Box>
                  <Box sx={classes.miniEcardInfo} flexGrow={1}>
                    <Box sx={classes.miniEcardRow}>
                      <Icon sx={classes.miniEcardIcon} fontSize="small">
                        mail_outline
                      </Icon>
                      <Box component="span" sx={classes.miniEcardValue}>
                        {window.LANG.ECARD_EMAIL_MASKED}
                      </Box>
                    </Box>
                    <Box sx={classes.miniEcardRow}>
                      <Icon sx={classes.miniEcardIcon} fontSize="small">
                        phone
                      </Icon>
                      <Box component="span" sx={classes.miniEcardValue}>
                        {window.LANG.ECARD_PHONE_MASKED}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )
            )}
            {addMessage ? (
              <Box pt={1}>
                <Box pb={1}>
                  <TextField
                    fullWidth
                    autoFocus
                    placeholder={window.LANG.ECARD_ADD_MESSAGE}
                    multiline
                    minRows={4}
                    maxRows={10}
                    slotProps={{ inputLabel: { shrink: true } }}
                    label={window.LANG.ECARD_MESSAGE_LABEL}
                    variant="outlined"
                    value={messageText}
                    onChange={(e) => setMessageText(e.target.value)}
                  />
                </Box>
                <Box display="flex" gap={1}>
                  <Button
                    fullWidth
                    color="primary"
                    onClick={() => setAddMessage(false)}
                    variant="outlined"
                    sx={classes.actionBtn}
                  >
                    {window.LANG.ECARD_CANCEL}
                  </Button>
                  <Button
                    fullWidth
                    color="primary"
                    onClick={toggleFollow}
                    variant="contained"
                    startIcon={<Icon>contact_mail</Icon>}
                    sx={classes.actionBtn}
                  >
                    {props.user.followsYou
                      ? window.LANG.ECARD_EXCHANGE
                      : window.LANG.ECARD_NOW_ASK}
                  </Button>
                </Box>
              </Box>
            ) : (
              <Box>
                <Button
                  fullWidth
                  color="primary"
                  onClick={() => setAddMessage(true)}
                  variant="contained"
                  startIcon={<Icon>contact_mail</Icon>}
                  sx={classes.actionBtn}
                >
                  {props.user.followsYou
                    ? window.LANG.ECARD_EXCHANGE_FULL
                    : window.LANG.ECARD_ASK_FULL}
                </Button>
              </Box>
            )}
          </Box>
        )}
      </Fade>

      {showLinkedIn && props.user.info_social_linkedin && (
        <Box pt={1}>
          <Button
            fullWidth
            component="a"
            href={
              props.user.info_social_linkedin.includes('linkedin.com')
                ? props.user.info_social_linkedin
                : `https://www.linkedin.com/in/${props.user.info_social_linkedin}`
            }
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            startIcon={<LinkedInIcon />}
            sx={{ ...classes.actionBtn, ...classes.linkedInBtn }}
          >
            {window.LANG.ECARD_VIEW_LINKEDIN}
          </Button>
        </Box>
      )}
      <Box display="flex" alignItems="stretch" gap={1} py={1}>
        {canIStartChat(
          conferenceState.conferenceDetail.chat_level,
          authState.user,
          props.user.followsYou
        ) && (
          <Button
            fullWidth
            startIcon={<Icon>forum</Icon>}
            color="primary"
            variant="contained"
            onClick={() => openNewThreadPopup([props.user])}
            sx={classes.actionBtn}
          >
            {window.LANG.ECARD_START_CHAT}
          </Button>
        )}
        {/* {authState.user.access_level === C.VISITOR.ACCESS_LEVEL.MODERATOR && (
          <Button
            fullWidth
            component={Link}
            target="_blank"
            href={`/profile/${props.user.id}`}
            color="primary"
            variant="outlined"
            endIcon={<Icon>launch</Icon>}
            sx={{ ...classes.actionBtn, ...classes.viewProfileBtn }}
          >
            {window.LANG.ECARD_VIEW_PROFILE}
          </Button>
        )} */}
      </Box>

      {showCustomFields && customRegistrationFields.length > 0 && (
        <Box mb={1.5} sx={classes.customFields}>
          {customRegistrationFields.map((field) => (
            <Box key={field.name} sx={classes.customFieldRow}>
              <Box sx={classes.customFieldLabel} title={field.label}>
                {field.label}
              </Box>
              <Box
                sx={classes.customFieldValue}
                title={formatFieldValue(field.value)}
              >
                {formatFieldValue(field.value)}
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default FollowToggle;
